<template>
  <div class="w-full">
    <!-- Main viewer -->
    <div class="rounded-2xl overflow-hidden bg-black flex items-center justify-center relative" style="height: 600px">
      <template v-if="currentItem">
        <img
          v-if="currentItem.type === 'photo'"
          :src="currentItem.src"
          :alt="currentItem.alt || 'photo'"
          class="w-full h-full object-cover cursor-pointer"
          @click="openLightbox(currentItem.src)"
        />

        <iframe
          v-else-if="currentItem.type === 'youtube'"
          class="w-full h-full"
          :src="`https://www.youtube.com/embed/${currentItem.videoId}?rel=0&autoplay=1`"
          frameborder="0"
          allowfullscreen
        ></iframe>

        <div
          v-else-if="currentItem.type === 'pano'"
          :id="panoId"
          ref="panoRef"
          class="w-full h-full"
        ></div>
      </template>
    </div>

    <!-- Thumbnails -->
    <div class="mt-4 overflow-x-auto">
      <div class="flex gap-4 min-w-[420px] pb-2" style="scrollbar-width: thin;">
        <button
          v-for="(item, idx) in items"
          :key="idx"
          type="button"
          class="aspect-video h-28 min-w-[140px] rounded-2xl overflow-hidden border-4 relative"
          :class="idx === current ? 'border-secondary' : 'border-transparent'"
          @click="show(idx)"
        >
          <img :src="item.thumb" class="w-full h-full object-cover" />
          <i
            v-if="item.type === 'youtube'"
            class="ph ph-play-fill absolute left-3 top-3 text-white text-xl"
          ></i>
          <i
            v-if="item.type === 'pano'"
            class="ph ph-globe-hemisphere-west absolute left-3 top-3 text-white text-xl"
          ></i>
        </button>
      </div>
    </div>

    <!-- Lightbox -->
    <Teleport to="body">
      <div
        v-if="lightbox"
        class="fixed inset-0 z-50 bg-black/80 flex items-center justify-center"
        @click="closeLightbox"
      >
        <img :src="lightboxImg" class="max-h-[90vh] max-w-[90vw] rounded-lg" />
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, onMounted } from 'vue';

const props = defineProps({
  items: { type: Array, default: () => [] },
  initial: { type: Number, default: 0 },
});

const panoId = `pano-${Math.random().toString(36).substring(2, 9)}`;
const current = ref(props.initial);
const lightbox = ref(false);
const lightboxImg = ref('');
const panoRef = ref(null);

const currentItem = computed(() => props.items[current.value]);

function show(idx) {
  current.value = idx;
  nextTick(() => {
    if (currentItem.value?.type === 'pano') initPano();
  });
}

function openLightbox(src) {
  lightbox.value = true;
  lightboxImg.value = src;
}

function closeLightbox() {
  lightbox.value = false;
  lightboxImg.value = '';
}

function initPano() {
  if (!currentItem.value || currentItem.value.type !== 'pano') return;
  if (!window.pannellum) return;
  window.pannellum.viewer(panoId, currentItem.value.panoData);
}

onMounted(() => {
  if (currentItem.value?.type === 'pano') {
    setTimeout(() => initPano(), 500);
  }
});
</script>
